import React from "react";
import { NumberInput, NumberInputField } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const getValidationValue = (field, type) =>
  field.validations?.find((item) => item.type === type && item.active !== false)?.value;

const NumberField = ({ field, control, disabled, error, required, compact }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required} compact={compact}>
        <NumberInput
          value={input.value ?? ""}
          min={getValidationValue(field, "MIN_VALUE")}
          max={getValidationValue(field, "MAX_VALUE")}
          precision={field.uiConfig?.precision}
          step={field.uiConfig?.step || 1}
          isDisabled={disabled}
          onChange={(_, valueAsNumber) => input.onChange(Number.isNaN(valueAsNumber) ? "" : valueAsNumber)}
        >
          <NumberInputField placeholder={field.placeholder} fontWeight={compact ? "semibold" : "normal"} />
        </NumberInput>
      </FieldFrame>
    )}
  />
);

export default NumberField;
